import React from "react";

// Import React FilePond
import { FilePond, registerPlugin } from "react-filepond";

// Import the plugin code
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Redux Imports
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { uploadSheet } from "../../Redux/Actions/dataActions";

registerPlugin(FilePondPluginFileValidateType);

// ⭐ Props erweitert um requestData und die Buttons aus dem Slider
// function DragNDrop({ giveModalData, requestData, secondButtonOnClick, secondButtonText, uploadSheet }) {
function DragNDrop(props) {
  const { giveModalData, requestData, secondButtonOnClick, secondButtonText, uploadSheet } = props;


  const uploadFinish = (files) => {
    if (files.length > 0) {
      giveModalData(files[0].file);
    }
  };

  const removeFile = () => {
    giveModalData(undefined);
  };

  // ⭐ Hilfsfunktion, die die Formulardaten sammelt und an Redux übergibt
  const handleSubmit = (e) => {
    e.preventDefault();
    
    const formData = new FormData();
    formData.append("file", requestData.uploadFile);
    formData.append("title", requestData.sheetName);
    formData.append("composer", requestData.composer);
    
    // ⭐ Die beiden neuen URL-Felder an das Backend mitsenden
    formData.append("sheet_image_url", requestData.sheetImageUrl || "");
    formData.append("composer_image_url", requestData.composerImageUrl || "");

    // Redux Action aufrufen und danach im Slider zum Abschluss-Fenster springen
    uploadSheet(formData, () => {
      secondButtonOnClick(e);
    });
  };

  return (
    <div className="upload-container">
      <FilePond
        onupdatefiles={(files) => {
          uploadFinish(files);
        }}
        onremovefile={removeFile}
        allowMultiple={false}
        server={{
          process: (
            fieldName,
            file,
            metadata,
            load,
            error,
            progress,
            abort,
            transfer,
            options
          ) => {
            load();
          },
        }}
        maxFiles={1}
        name="files"
        labelIdle='Drag & Drop your file or <span class="filepond--label-action">Browse</span>'
        credits={false}
        allowFileTypeValidation={true}
        acceptedFileTypes={["application/pdf"]}
      />

      {/* ⭐ Der "Next Step"-Button, der den Upload final ausführt */}
      <button
        disabled={!requestData || !requestData.uploadFile}
        className="first next interactive-form-button"
        onClick={handleSubmit}
        style={{ marginTop: "20px", width: "100%" }}
      >
        {secondButtonText}
      </button>
    </div>
  );
}

DragNDrop.propTypes = {
  uploadSheet: PropTypes.func.isRequired,
};

const mapActionsToProps = {
  uploadSheet,
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, mapActionsToProps)(DragNDrop);
